import React from 'react';
import { usePriceRowContext } from '../../../price-row-context';
import { useViewportContext } from 'src/components/viewport/context';
import RatingSmiley from '@prisjakt/ui-rating/src/smiley-rating';
import { RatingContainer } from './styles';

export const StoreRatingAverage: React.FC<React.PropsWithChildren<
  React.PropsWithChildren<unknown>
>> = () => {
  const { offer } = usePriceRowContext();
  const { store, rating } = offer;

  const { isMobile } = useViewportContext();

  if (!store || !rating || rating.whole <= 0) {
    return null;
  }

  return (
    <RatingContainer data-rating={rating.roundedString}>
      <RatingSmiley
        featured={Boolean(store.featured)}
        rating={rating}
        scoreVisibility="row"
        size="small"
        reviewCount={isMobile ? null : store.userReviewSummary.countTotal}
      />
    </RatingContainer>
  );
};
